<template>
  <script v-html="snippetData" type="application/ld+json"></script>
</template>

<script>
export default {
  name: 'RichSnippet',
  props: {
    data: Object,
  },
  data() {
    return {
      snippetData: {},
    }
  },
  computed: {
    // jsonld() {
    //   console.log(this.data)
    //   const jsonld = {
    //     '@context': 'https://schema.org/',
    //     '@type': 'Product',
    //     sku: `${this.data.id}`,
    //     image: [`${this.data.image}`],
    //     name: `${this.data.subtitle}`,
    //     description: `${this.data.title}`,
    //     brand: {
    //       '@type': 'Brand',
    //       name: 'Urlaubsgutschein',
    //     },
    //     offers: this.getOffers(),
    //   }
    //   return jsonld
    // },
  },
  watch: {
    data: function() {
      // watch it
      this.buildJsonLd()
    },
  },
  mounted() {
    this.buildJsonLd()
  },
  methods: {
    buildJsonLd() {
      if (this.data.variants != undefined) {
        const jsonld = {
          '@context': 'https://schema.org/',
          '@type': 'Product',
          sku: `${this.data.id}`,
          image: [
            `https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=500&gravity=smart&quality=50&interlace=true&type=auto&file=${this.data.image}`, // 1x1
            `https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=375&gravity=smart&quality=50&interlace=true&type=auto&file=${this.data.image}`, // 4x3
            `https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=282&gravity=smart&quality=50&interlace=true&type=auto&file=${this.data.image}`, // 16x9
          ],
          name: `${this.data.subtitle}`,
          description: `${this.data.title}`,
          brand: {
            '@type': 'Brand',
            name: 'Urlaubsgutschein',
          },
          offers: this.getOffers(),
        }
        this.snippetData = jsonld
      }
    },

    getOffers() {
      let date = new Date()

      let offers = this.data.variants.map(variant => {
        return {
          '@type': 'Offer',
          url: window.location.href,
          //itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          price: variant.price.display,
          priceCurrency: variant.price.currency,
          //priceValidUntil: date.toLocaleDateString('de-de', {year: 'numeric', month: 'numeric', day: 'numeric'}).replaceAll('.', '-'),
          priceValidUntil: date,
        }
      })

      return offers
    },
  },
}
</script>
